import React, { useContext } from 'react';
import { AppContext } from '../App';
import { 
  MdSecurity, 
  MdTrendingDown, 
  MdDevices, 
  MdGroups,
  MdArrowForward 
} from 'react-icons/md';

export default function WhyChooseUs() {
  const appContext = useContext(AppContext);

  const coreReasons = [
    {
      num: "01",
      icon: <MdSecurity size={32} />,
      title: "Ulinzi na Usalama wa Mitaji",
      description: "Amana na hisa zako zinalindwa kwa mifumo thabiti ya udhibiti wa kifedha na uwekezaji wa kimkakati ili kulinda ukwasi wako."
    },
    {
      num: "02",
      icon: <MdTrendingDown size={32} />,
      title: "Riba Nafuu na Masharti Rafiki",
      description: "Tunatoa mikopo ya maendeleo na dharura yenye kiwango kidogo cha riba ili kukuza mwanachama na si kumdidimiza."
    },
    {
      num: "03",
      icon: <MdDevices size={32} />,
      title: "Urahisi wa Kidijitali (Amala)",
      description: "Mfumo wetu wa Amala Portal unakuwezesha kupata huduma zote saa 24, kuangalia salio na kuomba mikopo kupitia simu yako."
    },
    {
      num: "04",
      icon: <MdGroups size={32} />,
      title: "Utawala Bora na Uwajibikaji",
      description: "Tunaongozwa na Bodi thabiti inayochaguliwa na wanachama, ikizingatia misingi mikuu ya uwazi na maadili mema."
    }
  ];

  return (
    <section className="WhyChooseUs py-5 position-relative overflow-hidden">
      {/* Background Decorative Blobs kwa ajili ya Ubunifu wa Kisasa */}
      <div className="abstract-blob blob-1"></div>
      <div className="abstract-blob blob-2"></div>

      <div className="container py-5 position-relative z-index-2">
        <div className="row g-5 align-items-center">
          
          {/* UPANDE WA KUSHOTO: Maudhui ya Kichwa cha Habari na CTA */}
          <div className="col-12 col-lg-5 text-start">
            <span className="premium-badge mb-3 d-inline-block">
              UTOFAUTI WETU WA KIMKAKATI
            </span>
            <h2 className="premium-section-title fw-bold text-dark mb-4">
              Kwa Nini Utegemee <span className="text-gradient">YCSC SACCOS?</span>
            </h2>
            <p className="premium-section-subtitle text-muted mb-4">
              Tunajenga daraja la uhakika linalokuunganisha na mafanikio ya kiuchumi kupitia misingi thabiti ya ushirika, uvumbuzi wa kidijitali na uaminifu mkuu wa kifedha.
            </p>

            {/* Takwimu za Haraka kuongeza Ushawishi */}
            <div className="row g-3 mb-5 src-stats-row">
              <div className="col-6">
                <div className="stat-item">
                  <h3 className="fw-bold text-primary mb-0">Saa 24</h3>
                  <small className="text-muted">Huduma za Amala Portal</small>
                </div>
              </div>
              <div className="col-6">
                <div className="stat-item">
                  <h3 className="fw-bold text-success mb-0">Riba</h3>
                  <small className="text-muted">Nafuu na Kidogo Sokoni</small>
                </div>
              </div>
            </div>

            {/* Kifungo Kipya Kinachopeleka Kwenye About Us Page */}
            <button 
              className="btn btn-premium-discover d-flex align-items-center gap-3"
              onClick={() => appContext.navTo({ item: "about_us" })}
            >
              <span>Fahamu Zaidi Kuhusu YCSC</span>
              <div className="arrow-circle d-flex align-items-center justify-content-center">
                <MdArrowForward size={18} />
              </div>
            </button>
          </div>

          {/* UPANDE WA KULIA: Gridi Imara ya Kadi (Asymmetric Staggered Cards) */}
          <div className="col-12 col-lg-7">
            <div className="row g-4 staggered-grid">
              
              {/* Safu ya Kwanza ya Kadi (Kadi 1 na 3) */}
              <div className="col-12 col-md-6 grid-col-left">
                {coreReasons.slice(0, 2).map((reason, idx) => (
                  <div key={idx} className="premium-u-card mb-4">
                    <span className="card-watermark-num">{reason.num}</span>
                    <div className="u-icon-wrapper mb-4 text-primary">
                      {reason.icon}
                    </div>
                    <h4 className="u-card-title fw-bold text-dark mb-3">
                      {reason.title}
                    </h4>
                    <p className="u-card-text text-muted mb-0">
                      {reason.description}
                    </p>
                  </div>
                ))}
              </div>

              {/* Safu ya Pili ya Kadi - Imehamishwa kidogo juu/chini CSS (Kadi 2 na 4) */}
              <div className="col-12 col-md-6 grid-col-right">
                {coreReasons.slice(2, 4).map((reason, idx) => (
                  <div key={idx} className="premium-u-card mb-4">
                    <span className="card-watermark-num">{reason.num}</span>
                    <div className="u-icon-wrapper mb-4 text-primary">
                      {reason.icon}
                    </div>
                    <h4 className="u-card-title fw-bold text-dark mb-3">
                      {reason.title}
                    </h4>
                    <p className="u-card-text text-muted mb-0">
                      {reason.description}
                    </p>
                  </div>
                ))}
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
}